// Mostly taken from PESV3-14679 and UI/src/js/common/utils/formatters.js:26 in PES
import isEmpty from 'lodash/isEmpty';
import escapeRegExp from 'lodash/escapeRegExp';
import { fractionDigits, LOCALE_FALLBACKS } from '../constants';
import { Options } from '../types/formatters/currency';

export const formatString = (str: string, replaceMap: Record<string, string>) => {
  if (!str || isEmpty(replaceMap)) {
    return str;
  }

  return Object.entries(replaceMap).reduce((acc, [ placeholder, value ]) => {
    return acc.replace(new RegExp(escapeRegExp(placeholder), 'g'), value);
  }, str);
};

export const format = (value: number, { locale }: Options): string => {
  const locales = LOCALE_FALLBACKS[locale] || locale;

  const formatter = new Intl.NumberFormat(locales, {
    minimumFractionDigits: fractionDigits.MIN,
    maximumFractionDigits: fractionDigits.MAX,
  });

  return formatter.format(value);
};

export const generateMedia = (minWidth: string, maxWidth: string): string => {
  const minWidthValue = minWidth ? `(min-width:${minWidth}px)` : '';
  const maxWidthValue = maxWidth ? `(max-width:${maxWidth}px)` : '';
  if (minWidthValue && maxWidthValue) {
    return `${minWidthValue} and ${maxWidthValue}`;
  }
  return minWidthValue || maxWidthValue;
};

export const decodeFromURI = (content: string) => decodeURIComponent(content.replace(/\+/g, '%20'));

export const generateSrcSet = (urls: string[]): string => {
  return urls?.join(',');
};
